const appstrings = {
    enterEmail: 'Please enter email id',
    invalidEmail: 'Please enter a valid email',
    enterPassword: 'Please enter password'
  }
  
  export default appstrings
  